import React, { useState } from "react";
import { Modal } from "antd";
import studentImg from "../../assets/images/std.png";
import techImg from "../../assets/images/tech.png";
import { Rating } from "react-simple-star-rating";
import styles from "./style.module.css";

const BothReviewModal = ({ isModalVisible, setIsModalVisible }) => {
  const [rating, setRating] = useState(3);
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const teachers = [
    {
      name: "Sara Yousuf",
      role: "Maths Teacher",
      image: techImg, // replace with actual path or import
      rating: 0, // Example rating
    },
    {
      name: "Khalid Osman",
      role: "Student",
      image: studentImg, // replace with actual path or import
      rating: 4, // Example rating
    },
  ];

  const handleRatingChange = (rating, teacherIndex) => {
    console.log(`New rating for teacher ${teacherIndex}: `, rating);
  };

  return (
    <>
      <Modal
        title=""
        footer={null}
        // visible={isModalVisible}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={750}
        style={{ top: 80 }}
      >
        <div className="row fs_18 fw-bolder px-3 pb-2">Both Reviews Modal</div>
        <div
          className={`row px-3 pb-3 overflow-y-scroll ${styles.reviews} ${styles.scrollbar_custom}`}
        >
          <div>
            {teachers.map((teacher, index) => (
              <div className="col-12 my-4 shadow" key={index}>
                <div className={`row bg-light ${styles.border_color}`}>
                  <div className="col-6 pt-3 text-left d-flex align-items-center">
                    <div className="pr-1">
                      <img
                        src={teacher.image}
                        alt="reviewIcon"
                        style={{
                          borderRadius: "50%",
                          border: "2px solid #fff",
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                      />
                    </div>
                    <div className="pl-2">
                      <span className="fs_12 font-weight-bold">
                        {teacher.name}
                      </span>
                      {/* <br /> */}
                      <span className="fs_12 font-weight-bold text-secondary pl-3">
                        {teacher.role}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 pt-3 d-flex align-items-center justify-content-end">
                    <Rating
                      className=""
                      size={20}
                      readonly
                      initialValue={rating}
                      onClick={(rating) => handleRatingChange(rating, index)}
                    />
                  </div>
                  <p className="row px-4 fs_12 mt-2">
                    In publishing and graphic design, Lorem ipsum is a
                    placeholder text commonly used to demonstrate the visual
                    form of a document or a typeface without relying on
                    meaningful content.
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BothReviewModal;
